import React from 'react';
import { useLingui } from '@lingui/react/macro';

import { Image } from '@rover/kibble/core';

type Props = {
  url: string;
  sitterName: string;
};

const StaticLocation = ({ url, sitterName }: Props): JSX.Element => {
  const { t } = useLingui();
  return (
    <Image
      src={url}
      description={t`${sitterName}'s Neighborhood`}
      width="100%"
      height="200px"
      borderRadius="primary"
    />
  );
};

export default StaticLocation;
